import { colors } from "../../Styles";

export function ArrowSmooth({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M197.08,232.22v-32.46h-82.48c-29.59,0-50.49-4.7-62.73-14.11-9.3-7.11-15.55-15.45-18.74-25.01-3.19-9.57-4.78-24.8-4.78-45.71v-31.21s7.68,0,7.68,0v4.23c0,18.82,4.34,31.86,13.02,39.13,8.68,7.27,24.36,10.9,47.04,10.9h100.99v-32.46s63.35,63.35,63.35,63.35l-63.35,63.35Z"/>
    </svg>
  );
}